import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

import { useAppDispatch, useAppSelector } from "../../../hooks/redux.hook";
import { commonSelector, rxCloseConfirmModal } from "../../../app/features/common/common.slice";
import { Spinner } from "../Spinner";
import FaIcon from "../FaIcon";

const ModalConfirm = () => {
  const dispatch = useAppDispatch();
  const { modalConfirm } = useAppSelector(commonSelector);
  const { isOpen, message, callbackYes, callbackNo, textButtonNo, textButtonYes } = modalConfirm;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                  <FaIcon prefix="fas" icon="triangle-exclamation" classes="text-yellow-500" /> Notificación
                </Dialog.Title>
                <div className="mt-2 text-justify">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="next-button mr-3 primary-button"
                    onClick={async () => {
                      setIsLoading(true);
                      await callbackYes();
                      dispatch(rxCloseConfirmModal());
                      setIsLoading(false);
                    }}
                  >
                    {isLoading && (
                      <div className="space-x-2 flex items-center">
                        <p className="text-blue-600">......</p>
                        <Spinner />
                        <p className="text-blue-600">......</p>
                      </div>
                    )}
                    {!isLoading && (
                      <div>
                        <i className="far fa-check mr-2 fa-fw" />
                        {textButtonYes}
                      </div>
                    )}
                  </button>
                  <button
                    type="button"
                    className="next-button default-button"
                    onClick={() => {
                      callbackNo();
                      dispatch(rxCloseConfirmModal());
                    }}
                  >
                    <i className="far fa-xmark mr-2 fa-fw" />
                    {textButtonNo}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalConfirm;
